import React from 'react';
import {
    Card, CardBody, CardTitle, CardImg,
    CardText, Col, Row, Container,
    Navbar, NavLink
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'
import scrollToComponent from 'react-scroll-to-component';
import AuthComponent from '../components/AuthComponent'
import '../styles/LinkPage.css'
//toniolo
import GiuseppeToniolo from '../docs/GiuseppeToniolo.js';
import ritrattoToniolo from '../images/Famosi/Giuseppe_Toniolo.jpg'
import ritrattoMariaToniolo from '../images/Famosi/Maria_Schiratti_ved_Toniolo.jpg'
import ritrattogToniolo from '../images/Famosi/330px-Toniolo.jpg'
import news1Toniolo from '../images/Famosi/chieraToniolo1.jpg'
import news2Toniolo from '../images/Famosi/chieraToniolo2.jpg'
//salvioni
import EmiliaSalvioni from '../docs/EmiliaSalvioni.js';
import ritrattoSalvioni from '../images/Famosi/EmiliaSalvioni.jpg'
import withSister from '../images/Famosi/1902_Emilia_con_Anna.jpg'
import pieveDiSoligo from '../images/Famosi/1915_porta_casa_di_Pieve_di_Soligo.jpg'
import setteCugine from '../images/Famosi/1915_sette_cugine_Schiratti_Toniolo_e_Salvioni.jpg'
import lastPicture from '../images/Famosi/1967_con_sorella_ultima_forografia.jpg'
//schiratti
import AntonioSchiratti from '../docs/AntonioSchiratti.js';
import ritrattoAntonio from '../images/Famosi/AntonioSchiratti.jpg'

export default class EventsPage extends AuthComponent {

    render() {
        return (
            <Container className="LinkPage">
                <div className='Top' ref={(div) => { this.TopSection = div; }}></div>
                <h4>PERSONAGGI FAMOSI</h4>
                <h6>Nella nostra famiglia ci sono stati vari personaggi che si sono distinti nelle loro professioni e
                sono diventati famosi nella storia italiana. In questa pagina li vogliamo ricordare per il loro
                contributo alla societa'.
                Le loro vite con il loro esempio hanno influenzato le vite dei nostri nonni, forse nelle loro scelte
                in famiglia e professionali. Consideriamo la possibilità che in parte abbiamo influenzato anche le nostre.
                </h6>
                <Navbar bsstyle="tabs" style={{ justifyContent: 'flex-start' }}>
                    <NavLink
                        className="scrolltoToniolo"
                        onClick={() => scrollToComponent(this.TonioloSection, { offset: 0, align: 'top', duration: 500, ease: 'inCirc' })}>
                        Giuseppe Toniolo
                    </NavLink>
                    <NavLink
                        className="scrolltoSalvioni"
                        onClick={() => scrollToComponent(this.SalvioniSection, { offset: 0, align: 'top', duration: 500, ease: 'inCirc' })}>
                        Emilia Salvioni
                    </NavLink>
                    <NavLink
                        className="scrolltoSchiratti"
                        onClick={() => scrollToComponent(this.SchirattiSection, { offset: 0, align: 'top', duration: 500, ease: 'inCirc' })}>
                        Antonio Schiratti
                    </NavLink>
                </Navbar>
                <Row className="grandparents-row">
                    <Col sm={{ size: 5 }}>
                        <Card>
                            <CardImg top width="100%" src={ritrattoToniolo} alt="Giuseppe Toniolo" />
                        </Card>
                        <Card>
                            <CardImg top width="100%" src={ritrattoMariaToniolo} alt="Maria Schiratti vedova Toniolo" />
                        </Card>
                        <Card>
                            <CardImg top width="100%" src={ritrattogToniolo} alt="Maria Schiratti vedova Toniolo" />
                        </Card>
                    </Col>
                    <Col sm={{ size: 7, offset: 0.1 }}>
                        <Card>
                            <CardBody>
                                <div className='TonioloSection' ref={(div) => { this.TonioloSection = div; }}>
                                    <NavLink className="scrolltoTop" onClick={() => scrollToComponent(this.TopSection, { offset: 0, align: 'top', duration: 500, ease: 'inCirc' })}>
                                        Ritorna <FontAwesomeIcon icon={faAngleUp} />
                                    </NavLink>
                                    <CardTitle>GIUSEPPE TONIOLO</CardTitle>
                                    <GiuseppeToniolo></GiuseppeToniolo>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardImg top width="50%" src={news1Toniolo} alt="Giuseppe Toniolo sui giornali" />
                        </Card>
                        <Card>
                            <CardImg top width="50%" src={news2Toniolo} alt="Giuseppe Toniolo sui giornali" />
                        </Card>
                    </Col>
                </Row>
                <br />
                <Row className="grandparents-row">
                    <Col sm={{ size: 5 }}>
                        <Card>
                            <CardImg top width="50%" src={ritrattoSalvioni} alt="Emilia Salvioni" />
                            <CardText>Emilia Salvioni</CardText>
                        </Card>
                        <Card>
                            <CardImg top width="50%" src={withSister} alt="Emilia ed Anna Salvioni - 1902" />
                            <CardText>Emilia ed Anna Salvioni - 1902</CardText>
                        </Card>
                        <Card>
                            <CardImg top width="50%" src={pieveDiSoligo} alt="Porta di casa a Pieve di Soligo - 1915" />
                            <CardText>Porta di casa a Pieve di Soligo - 1915</CardText>
                        </Card>
                        <Card>
                            <CardImg top width="50%" src={setteCugine} alt="Sette cugine Schiratti, Toniolo e Salvioni - 1915" />
                            <CardText>Sette cugine Schiratti, Toniolo e Salvioni - 1915</CardText>
                        </Card>
                        <Card>
                            <CardImg top width="50%" src={lastPicture} alt="Ultima foto con la sorella - 1967" />
                            <CardText>Ultima foto con la sorella - 1967</CardText>
                        </Card>
                    </Col>
                    <Col sm={{ size: 7, offset: 0.1 }}>
                        <Card>
                            <CardBody>
                                <div className='SalvioniSection' ref={(div) => { this.SalvioniSection = div; }}>
                                    <NavLink className="scrolltoTop" onClick={() => scrollToComponent(this.TopSection, { offset: 0, align: 'top', duration: 500, ease: 'inCirc' })}>
                                        Ritorna <FontAwesomeIcon icon={faAngleUp} />
                                    </NavLink>
                                    <CardTitle>EMILIA SALVIONI</CardTitle>
                                    <EmiliaSalvioni></EmiliaSalvioni>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="grandparents-row">
                    <Col sm={{ size: 5 }}>
                        <Card>
                            <CardImg top width="100%" src={ritrattoAntonio} alt="Antonio Schiratti" />
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div className='SchirattiSection' ref={(div) => { this.SchirattiSection = div; }}>
                                    <NavLink className="scrolltoTop" onClick={() => scrollToComponent(this.TopSection, { offset: 0, align: 'top', duration: 500, ease: 'inCirc' })}>
                                        Ritorna <FontAwesomeIcon icon={faAngleUp} />
                                    </NavLink>
                                    <CardTitle>ANTONIO SCHIRATTI</CardTitle>
                                    <span>
                    Antonio Schiratti fu il primo figlio di Tomaso Schiratti e di Maria Burei, fratello maggiore dei sei fratelli
                    Schiratti. Sottotenente di fanteria immolò la sua giovane vita per la Patria nel 1913 nella
                    guerra di Libia. Venne insignito della Medaglia d'Argento al valor militare ed il
                    decreto reale porta le seguenti parole:<br />
                    S. M. il RE, con decreto del 9 aprile 1914, visto il Regio Viglietto 26 marzo
                    1833 sulla proposta del Ministro Segretario di Stato per gli affari di guerra
                    ha conferito la MEDAGLIA D'ARGENTO AL VALORE MILITARE alla memoria del Sottotenente del 7° 
                    Reggimento Fanteria Schiratti Antonio nato a Pieve di Soligo (Treviso) 
                    nel 1889 e morto a SIDI GARBAA il 16 maggio 1913.<br />
                    "In tutta la giornata diede prove continue di coraggio e slancio. Ferito
                    gravemente una prima volta al petto, non abbandonò il comando del
                    plotone, anzi continuò ad incitare i soldati a resistere. Mentre pronunciava
                    parole sublimi di incoraggiamento venne nuovamente colpito alla testa".
                     
                    <p />
                    <b>Contesto storico dell’Italia nel 1913</b><br />
                    Nel 1913, l’Italia era un paese relativamente giovane, unificato solo da poco più di cinquant’anni. 
                    Il Regno d’Italia, guidato da Vittorio Emanuele III e dal governo liberale, cercava di affermarsi 
                    come potenza coloniale al pari di Francia, Inghilterra e Germania. 
                    L’industrializzazione era in corso, ma ancora concentrata nel Nord, mentre il Sud restava prevalentemente 
                    agricolo e povero. Politicamente, il paese era dominato da una classe dirigente borghese e monarchica, 
                    con forti tensioni sociali e crescenti movimenti operai e socialisti.
                    <br />
                    Sul piano internazionale, l’Italia cercava di espandere il proprio impero coloniale. Dopo aver ottenuto 
                    l’Eritrea e la Somalia alla fine dell’Ottocento, guardava con interesse alla Libia, allora parte 
                    dell’Impero Ottomano. La posizione geografica della Libia, di fronte alle coste italiane, la rendeva 
                    particolarmente strategica e attraente per Roma, che vedeva in essa un modo per consolidare il proprio 
                    prestigio e accrescere le proprie risorse economiche e politiche.
                    <br />
                    Nel 1911, approfittando della debolezza dell’Impero Ottomano, l’Italia dichiarò guerra e lanciò l’invasione 
                    della Libia. La cosiddetta Guerra italo-turca durò circa un anno e si concluse nel 1912 con il Trattato di 
                    Losanna, con cui l’Impero Ottomano cedeva formalmente all’Italia le regioni della Tripolitania, Cirenaica 
                    e Fezzan. Tuttavia, la conquista non fu affatto pacifica: molte tribù locali continuarono a resistere 
                    all’occupazione italiana anche negli anni successivi.
                    <br />
                    Nel 1913, quindi, l’Italia era ancora impegnata a sedare la resistenza libica e a stabilire un controllo reale 
                    sul territorio. La guerra in Libia divenne anche un tema controverso in patria: se da un lato fu usata dalla 
                    propaganda per esaltare il nazionalismo italiano, dall’altro suscitò critiche per i costi economici e umani e 
                    per l’uso della forza contro la popolazione locale. Questo contesto contribuì a un clima politico sempre più 
                    instabile, alle soglie della Prima Guerra Mondiale.

                </span>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <AntonioSchiratti></AntonioSchiratti>
                </Row>

            </Container>
        )
    }
}